import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'When would you like the payee to receive this payment?',
	description:
		'International payments can be processed on business banking days (subject to currency cut-off times). The length of time it’ll take to reach the payee’s account will depend on when the money’s sent, what currency you’re sending and what country you’re sending it to.',
	urgentPaymentLabel: 'This is an urgent payment',
	urgentPaymentInfo:
		'If you’re sending euros to a country in the European Economic Area (EEA) – and it’s not an urgent payment – you can unselect this checkbox and we’ll make a next-day SEPA payment, which is less expensive.',
	invalidValidationMessage: 'Invalid Message',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
